import { MenuLateral } from '@/components/shared/MenuLateral';
import { Comunidade } from '@/pages/Feagri/Comunidade';
import { CorpoDocente } from '@/pages/Feagri/Comunidade/CorpoDocente';
import { Funcionarios } from '@/pages/Feagri/Comunidade/Funcionarios';
import { ComposicaoEspecialista } from '@/pages/Feagri/EstruturaOrganizacional/Administracao/ComissaoEspecialista';
import { ComposicaoCIPA } from '@/pages/Feagri/EstruturaOrganizacional/ComposicaoCIPA';
import { ComposicaoCONEST } from '@/pages/Feagri/EstruturaOrganizacional/ComposicaoCONEST';
import { ComposicaoCONG } from '@/pages/Feagri/EstruturaOrganizacional/ComposicaoCONG';
import { ComposicaoCSARH } from '@/pages/Feagri/EstruturaOrganizacional/ComposicaoCSARH';
import { ComposicaoCIIR } from '@/pages/Feagri/EstruturaOrganizacional/Conselhos/ComposicaoCIIR';
import { ComposicaoCIPG } from '@/pages/Feagri/EstruturaOrganizacional/Conselhos/ComposicaoCIPG';
import { ComposicaoCITP } from '@/pages/Feagri/EstruturaOrganizacional/Conselhos/ComposicaoCITP';
import { GaleriaFotos } from '@/pages/Feagri/GaleriaFotos';

import { Route, Routes } from 'react-router-dom';


const FeagriRoutes = () => {

    return (
        <div className='flex'>
            <MenuLateral
                title='FEAGRI'
                menuType='menu-feagri'
            />

            <div className='pl-10 w-full'>
                <Routes>
                    <Route path='/comunidade' element={<Comunidade />} />
                    <Route path='/comunidade/corpo-docente' element={<CorpoDocente />} />
                    <Route path='/comunidade/funcionarios' element={<Funcionarios />} />

                    <Route path='/estrutura-organizacional/congregacao/composicao-congregacao' element={<ComposicaoCONG />} />
                    <Route path='/estrutura-organizacional/conselho-estrategico-conest/composicao-conest' element={<ComposicaoCONEST />} />
                    <Route path='/estrutura-organizacional/csarh/composicao-csa-rh' element={<ComposicaoCSARH />} />
                    <Route path='/estrutura-organizacional/cipa/composicao-cipa' element={<ComposicaoCIPA />} />
                    <Route path='/estrutura-organizacional/administracao/comissao-de-especialista/composicao-comissao-de-especialista' element={<ComposicaoEspecialista />} />

                    <Route path='/conselhos/ciir/composicao-ciir' element={<ComposicaoCIIR />} />
                    <Route path='/conselhos/cipg/composicao-cipg' element={<ComposicaoCIPG />} />
                    <Route path='/conselhos/citp/composicao-citp' element={<ComposicaoCITP />} />

                    <Route path='galeria-de-fotos' element={<GaleriaFotos />} />

                </Routes>
            </div>
        </div>
    );
}

export { FeagriRoutes };